import Organisation from './Organisation';

export default Organisation;
